import org from './org';
import syscode from './syscode';
import sysmodule from './sysmodule';
import employee from './employee';
import account from './account';
import student from './student';
import classes from './classes';
import course from './course';
import sysparam from './sysparam';
import term from './term';
import reports from './reports';
import plans from './plans';
import file from './file';
import evals from './evals';
import items from './items';
import score from './score';
import folder from './folder';
import sysinit from './sysinit';
import auth from './auth';
import authtree from './authtree';
import attachment from './attachment';
import mobile from './mobile';
import logs from './logs';
import roles from './roles';
import user from './user';
import muleval from './muleval';
import home from './home';
import exstudent from './exstudent';
import task from './task';
import scorecomment from './scorecomment';
import targetAnalysisByOrg from './targetAnalysisByOrg';
import statTargetAnalysisByEmployee from './statTargetAnalysisByEmployee';
import targetAnalysisByTarget from './targetAnalysisByTarget';
import targetAnalysisByTerm from './targetAnalysisByTerm';
import evalResultImport from './evalResultImport';
import evalTargetImport from './evalTargetImport';
import studentLeaderImport from './studentLeaderImport';
import studentLeaderAssignImport from './studentLeaderAssignImport';
import databack from './databack';
import teacherrank from './teacherrank';
import teacherclassrank from './teacherClassrank';
import teacherclscourank from './teacherClsCourank';
import courserank from './courserank';
import majorrank from './majorrank';
import teacherCourseRank from './teacherCourseRank';
import evaluationOrg from './evaluationOrg';
import evaluationClass from './evaluationClass';
import evaluationStudent from './evaluationStudent';
import questionTree from './questionTree';
import questionManage from './qmanage';
import question from './question';
import options from './options';
import questionOptions from './questionOptions';
import surveyPublish from './surveyPublish';
import evalSurvey from './evalSurvey';
import targetAnalysisDiffOrg from './targetAnalysisDiffOrg';
import evalTeacher from './evalTeacher';
//教师自评
import teachereval from './teachereval';


import register from './register';
import review from './review';
import school from './school';

import earlyWarningByOrg from './earlyWarningByOrg';
import earlyWarningByStudent from './earlyWarningByStudent';
import earlyWarningByCourse from './earlyWarningByCourse';
import customizeTargetAnalysis from './targetAnalysisByCustomize';
import roleAuth from './roleAuth';
import zyzg from './zyzg';
import jszg from './jszg'
import develop from './develop';
import szyreview from './szyreview';
import monitor from './monitor'
import kczg from './kczg';
import ciqa from './ciqa'
import exstudentLeader from './exstudentLeader'
import courseAssess from './courseAssess';
import teacherOneselfDiagnose from './teacherOneselfDiagnose';
import zgcp from './zgcp';
import supv from './supv';
import apiPermission from './apiPermission';
import academy from './academy';
import resultImport from './resultImport';
import targetAndOrgAnalysisByTermOrYear from './targetAndOrgAnalysisByTermOrYear';
import datacenter from './datacenter';
import leaderListen from './leaderListen';
import studentRole from './studentRole';
import secondCredit from './secondCredit';
import patrol from './patrol';

import graduation from './graduation';
import graduationEntring from './graduationEntring';
import studentByLegislationAssign from './studentByLegislationAssign';

import roleImport from './roleImport';
import academicGuidance from './academicGuidance';
import assessmentEvaluation from './assessmentEvaluation';
import dataImport from './dataImport';

import teacherQualityReport from './teacherQualityReport';

import targetConfig from './targetConfig';
import scientificResearch from './scientificResearch';

import teacherTeachingQuality from './teacherTeachingQuality';
import major from './major';
import dataStatistics from './dataStatistics';
import message from './message';

import icon from './icon';

import alongClass from './alongClass';
import sysCodeTree from './sysCodeTree';
import dtme from './dtme';
import grade from './grade';
import gradeSummaryImport from './gradeSummaryImport';
import dataSync from './dataSync';
import messageChat from './messageChat';
import teacherQualitySummary from './teacherQualitySummary'
import ods from './ods';
import evalCollectRank from './evalCollectRank';
import evalDataSummary from './evalDataSummary';
import license from './license';
import dossier from './dossier';
import teacherTeachingQualityReport from './teacherTeachingQualityReport';
import classroomCertificationAnalysis from './classroomCertificationAnalysis';
import evalAnalysisOrgAuth from './evalAnalysisOrgAuth';
import majorgroup from './majorgroup';
import jxcpReport from './jxcpReport';
import jxcpReportTerm from './jxcpReportTerm';
import reverseEval from './reverseEval';
import auditingAuthorizeImport from './auditingAuthorizeImport';
import openingTeacherSummary from './openingTeacherSummary';
import courseTargetAnalysis from './courseTargetAnalysis';
import project from './project';
import dataCorrection from './dataCorrection';

export default {
    targetAnalysisByOrg,
    evalResultImport,
    evalTargetImport,
    studentLeaderImport,
    studentLeaderAssignImport,
    statTargetAnalysisByEmployee,
    targetAnalysisByTarget,
    targetAnalysisByTerm,
    targetAndOrgAnalysisByTermOrYear,
    scorecomment,
    exstudent,
    sysinit,
    task,
    org,
    logs,
    roles,
    user,
    employee,
    account,
    student,
    classes,
    course,
    sysparam,
    term,
    reports,
    plans,
    file,
    syscode,
    sysmodule,
    evals,
    items,
    score,
    folder,
    auth,
    authtree,
    attachment,
    mobile,
    muleval,
    home,
    databack,
    teacherrank,
    teacherclassrank,
    teacherclscourank,
    courserank,
    majorrank,
    teacherCourseRank,
    evaluationOrg,
    evaluationClass,
    evaluationStudent,
    questionTree,
    questionManage,
    question,
    options,
    questionOptions,
    surveyPublish,
    evalSurvey,
    targetAnalysisDiffOrg,
    evalTeacher,
    earlyWarningByOrg,
    earlyWarningByStudent,
    earlyWarningByCourse,
    customizeTargetAnalysis,
    zyzg,
    teachereval,
    register,
    review,
    school,
    roleAuth,
    jszg,
    develop,
    szyreview,
    monitor,
    kczg,
    ciqa,
    exstudentLeader,
    courseAssess,
    teacherOneselfDiagnose,
    zgcp,
    supv,
    apiPermission,
    academy,
    resultImport,
    datacenter,
    leaderListen,
    studentRole,
    secondCredit,
    patrol,
    graduation,
    graduationEntring,
    studentByLegislationAssign,
    roleImport,
    academicGuidance,
    assessmentEvaluation,
    dataImport,
    teacherQualityReport,
    targetConfig,
    scientificResearch,
    teacherTeachingQuality,
    major,
    dataStatistics,
    message,
    icon,
    alongClass,
    sysCodeTree,
    dtme,
    grade,
    gradeSummaryImport,
    dataSync,
    messageChat,
    teacherQualitySummary,
    ods,
    evalCollectRank,
    evalDataSummary,
    license,
    dossier,
    teacherTeachingQualityReport,
    classroomCertificationAnalysis,
    evalAnalysisOrgAuth,
    majorgroup,
    jxcpReport,
    jxcpReportTerm,
    reverseEval,
    auditingAuthorizeImport,
    openingTeacherSummary,
    project,
    dataCorrection,
    courseTargetAnalysis,
}